import styled from "@emotion/styled";

import { theme } from "../../../../Internals/ThemeProvider/CandyTheme/ThemeShorthand";

export const Progress = styled.div(props => ({
    height: 1,
    backgroundColor: theme(props).keyPalette.panel2BackgroundColor,
    boxSizing: "border-box",
}));

export const ProgressLoading = styled.div(props => ({
    height: 1,
    backgroundColor: theme(props).semanticColors.action.alternativeColor,
}));
